/**
 * Note: properties starting with a '_' are removed before sending
 *
 * @module app.model
 * @license Copyright 2013 (c) RISE Ges.m.b.H.
 *  ____   ___  ____   _____
 * |  _ \  | | / ___| | ____|
 * | |_) | | | \___ \ |  _|
 * |  _ <  | |  ___) || |___
 * |_| \_\ |_| |____/ |_____|
 *
 */
(function(app) {
    "use strict";

    // Models _need_ to be a function with a name (NOT an anonymous function!)
    app.model.Tag = function Tag(json) {
        var obj = (typeof json === 'string') ? JSON.parse(json) : json;

        if (!obj) {
            obj = {};
        }

        this.id = obj.id != null ? obj.id : null;
        this.name = obj.name != null ? obj.name : null;
        this.description = obj.description != null ? obj.description : null;
        this.object_id = obj.object_id != null ? obj.object_id : null;
        this.nfc_serial = obj.nfc_serial != null ? obj.nfc_serial : null;
        this.active = obj.active != null ? obj.active : null;
        this.tag_type = obj.tag_type != null ? obj.tag_type : null;
        this.longitude = obj.longitude != null ? parseFloat(obj.longitude) : null;
        this.latitude = obj.latitude != null ? parseFloat(obj.latitude) : null;

        if (obj.hasOwnProperty('object_name')) {
            this.object_name = obj.object_name;
        }

        if (obj.hasOwnProperty('location_name')) {
            this.location_name = obj.location_name;
        }

        if (obj.hasOwnProperty('customer_name')) {
            this.customer_name = obj.customer_name;
        }

        if (obj.hasOwnProperty('customer_id')) {
            this.customer_id = obj.customer_id;
        }

        if (obj.hasOwnProperty('location_id')) {
            this.location_id = obj.location_id;
        }

        if (obj.hasOwnProperty('is_fully_editable')) {
            this.is_fully_editable = obj.is_fully_editable;
        }

        /**
         * set on server side
         * @type {JustDate}
         */
        this.created_at = obj.created_at ?
            typeof obj.created_at === 'string' ?
                Date.fromISO(obj.created_at)
                : obj.created_at
            : null;

        this.last_programmed_at =  obj.last_programmed_at ?
            typeof obj.last_programmed_at === 'string' ?
                Date.fromISO(obj.last_programmed_at)
                : obj.last_programmed_at
            : null;
    };

}(window.app));
